import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  CreditCardAssignee,
  type CreditCardAssigneeConstructor,
} from './CreditCardAssignee'

export const CreditCardAssigneeConstructorFactory =
  Factory.Sync.makeFactory<CreditCardAssigneeConstructor>({
    id: Factory.each(() => faker.random.number()),
    firstName: Factory.each(() => faker.name.firstName()),
    lastName: Factory.each(() => faker.name.lastName()),
    email: Factory.each(() => faker.internet.email()),
    position: Factory.each(() => faker.name.jobTitle()),
    profileImage: null,
  })

export const CreditCardAssigneeFactory = EntityFactory(
  CreditCardAssignee,
  CreditCardAssigneeConstructorFactory
)
